import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../ui/button'
import AddBotForm from './AddBotForm'
import { addBot, getGameId, getMe, getPlayers, startGame } from './gameSlice'
import styles from './GameLobbyContainer.module.css'
import JoinGameForm from './JoinGameForm'
import AppLayout from '../../app-layout'
import useGameCode from '../share/useGameCode'
import Card from '../../ui/card'
import { ContentCopyIcon } from '../../ui/icon'
import copy from 'copy-to-clipboard'

export default function GameLobbyContainer() {
    const me = useSelector(getMe)
    
    const controls = me ?
        <WaitForPlayersControls /> :
        <JoinGameControls />

    return (
        <AppLayout
            bottomBar={controls}
        >
            <>
                <ShareCodeCard />
                <PlayerListCard />
            </>
        </AppLayout>
    )
}

const WaitForPlayersControls = () => {
    const dispatch = useDispatch()
    const [isAddingBot, setIsAddingBot] = useState(false)
    const submitBot = useCallback(({ name }) => {
        dispatch(addBot({ name }))
        setIsAddingBot(false)
    }, [dispatch, setIsAddingBot])
    const start = useCallback(() => {
        dispatch(startGame())
    }, [dispatch])

    if (isAddingBot) {
        return (
            <div className={styles.waitForPlayersControls}>
                <AddBotForm
                    onSubmit={submitBot}
                    onCancel={() => setIsAddingBot(false)}
                />
            </div>
        )
    }
    return (
        <div className={styles.waitForPlayersControls}>
            <Button variant="outlined" onClick={start}>
                Start Game
            </Button>
            <Button variant="text" onClick={() => setIsAddingBot(true)}>
                Add a bot
            </Button>
        </div>
    )
}

const JoinGameControls = () => (
    <div className={styles.joinGameControls}>
        <JoinGameForm />
    </div>
)

const ShareCodeCard = () => {
    const gameId = useSelector(getGameId)
    const shareCode = useGameCode(gameId || "")
    const handleCopy = useCallback(() => copy(shareCode.code || ""), [shareCode])
    
    return (
        <Card title="Game code">
            <div className={styles.shareCode}>
                <span>{shareCode.isLoading ? "_ _ _ _ _ _" : shareCode.code}</span>
                <Button
                    disabled={shareCode.isLoading}
                    icon={ContentCopyIcon}
                    onClick={handleCopy}
                />
            </div>
        </Card>
    )
}

const PlayerListCard = () => {
    const players = useSelector(getPlayers)

    if (players.length === 0) {
        return (
            <Card title="Players">
                <p style={{
                    textAlign: 'center',
                    padding: "20px 10px",
                    fontStyle: "italic",
                }}>
                    No player has joined this game yet.
                </p>
            </Card>
        )
    }

    const playerNodes = players.map(p => (
        <li key={p.id} className={styles.playerListPlayer}>
            {p.name} { p.isMe &&
                <em>(you)</em>
            }
        </li>
    ))

    return (
        <Card title="Players">
            <ul className={styles.playerList}>
                {playerNodes}
            </ul>
        </Card>
    )
}